<label for="vatId" class="form-label" translate="field.vatId"></label>
<div [formGroup]="registerForm" class="input-group has-validation">
  <input type="text" class="form-control" id="vatId" formControlName="vatId"
         [ngClass]="{ 'is-invalid': isInvalid() }"
  />
  <div class="invalid-feedback" translate="field.required"></div>
</div>
<div class="form-text small" translate="field.optional" *ngIf="isOptional"></div>
